module.exports = __webpack_public_path__ + "img/just-r-logo.4ee5d232.png";